import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import router from './components/Routing/Routing';
import ReduxProvider from './context/ReduxProvider';
import store from './data/store';
import './styles/index.scss';

const container = document.getElementById('owl-frontend-app-bluejay-root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ReduxProvider reduxStore={store.reduxStore}>
      <RouterProvider router={router} />
    </ReduxProvider>
  </React.StrictMode>
);
